<template>
	<div class="l-body">
		<Top/>
		<div class="wrap" :class="bgId">
			<div class="l-wrap zheng">
				<div class="faqtit"><span id="game">{{game}}</span><span>-</span><span id="faqtype">常见问题</span></div>
					<div class="faq_changjian" style="cursor:pointer">
						<a @click="change1($event)" :class="show1==true?'ok':''">查询找回相关问题</a>
						<a @click="change2($event)" :class="show2==true?'ok':''">账号服务相关问题</a>
						<a @click="change3($event)" :class="show3==true?'ok':''">其他问题</a>
					</div>
				<div class="help-jl-box" style="width:100%;" v-show="theshow1">
					<router-view/>
				</div>
				<div class="help-jl-box" style="width:100%;" v-show="theshow">
					<h1><span id="game">{{game}}</span><span>-</span><span id="faqtype">{{antext}}</span></h1>
					<h2>customer service</h2>
					<div class="wentilist" style="width:90%;margin-left:55px">

						<ul id="nav" v-show="show1">
						<li class="list"><i></i><a @click="t('/common/ro2')"><h3>物品被盗如何申请找回</h3></a></li>
						<li class="list"><i></i><a @click="t('/common/ro3')"><h3>物品丢失、物品异常</h3></a></li>
						<li class="list"><i></i><a @click="t('/common/ro4')"><h3>买到被盗物品怎么办</h3></a></li>
						<li class="list"><i></i><a @click="t('/common/sun8')"><h3>防盗防骗小常识</h3></a></li>
						</ul>
						<ul id="nav" v-show="show2">
						<li class="list"><i></i><a @click="t('/common/ro7')"><h3>账号找回</h3></a></li>
						<li class="list"><i></i><a @click="t('/common/ro10')"><h3>账号注销</h3></a></li>
						</ul>
						<ul id="nav" v-show="show3">
						<li class="list"><i></i><a @click="t('/common/sun18')"><h3>举报违规、封停申诉</h3></a></li>
						<li class="list"><i></i><a @click="t('/common/sun22')"><h3>意见建议、问题提交</h3></a></li>
						</ul>
					</div>
					<div class="hujiao" style="float:left;">
						<p>您的问题是否得到了解决？如果没有，您可以尝试：</p>
						<p>呼叫在线客服：<a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>在线客服</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Top from '@/components/top.vue'
  export default {
    name: "common",
    components: {
      Top
    },
	data () {
	  return {
	    id:this.$route.query.id||localStorage.getItem('id'),
	    game:this.$route.query.name||localStorage.getItem('game'),
		qq:false,
    bgId:'',
		//show:true,
		show1:true,
		show2:false,
		show3:false,
		theshow:true,
		theshow1:false,
		antext:'安全服务相关问题'
	  }
	},
	created() {
	  localStorage.setItem('id',this.id)
	  localStorage.setItem('game', this.game)
    this.bgId='ro'
	},
	watch: {
		$route(to , from){
			if(to.path=='/common'){
				this.theshow=true
				this.theshow1=false
			}
		}
	 },
	methods:{
	  change1(val){
	  this.show1=true;
	  this.show2=false;
	  this.show3=false;
		this.theshow=true
		this.theshow1=false
		this.antext=val.target.innerText
	  },
	  change2(val){
		this.show2=true;
		this.show1=false;
		this.show3=false;
		this.theshow=true
		this.theshow1=false
		this.antext=val.target.innerText
	  },
	  change3(val){
		this.show3=true;
		this.show1=false;
		this.show2=false;
		this.theshow=true
		this.theshow1=false
		this.antext=val.target.innerText
	  },
	  t(meg){
		  this.theshow=false
		  this.theshow1=true
		  this.$router.push({path:meg})
	  }
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/common.vue